// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25SYn","textarea":"styles_textarea__D-VvF"};